export const SEGMENT_A = "a"
export const SEGMENT_B = "b"
export const SEGMENT_C = "c"
export const SEGMENT_D = "d"
export const SEGMENT_E = "e"

export const SEGMENTS = [
  SEGMENT_A,
  SEGMENT_B,
  SEGMENT_C,
  SEGMENT_D,
  SEGMENT_E,
]

export const DEFAULT_SEGMENTS = [SEGMENT_A]
